import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dra",
  "use": "icon-dra-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-dra\"><path d=\"M896 768a64 64 0 1 1 0-128 64 64 0 0 1 0 128z m-384 0a64 64 0 1 1 0-128 64 64 0 0 1 0 128z m-383.936 0a64 64 0 1 1 0-128 64 64 0 0 1 0 128z m768-320A64 64 0 1 1 896 320a64 64 0 0 1 0 128zM512 448A64 64 0 1 1 512 320a64 64 0 0 1 0 128zM128 448a64 64 0 1 1 0-128 64 64 0 0 1 0 128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol